export type UserRole = 'locum' | 'pharmacy' | 'admin';

export interface AuthUser {
  id: number;
  name?: string;
  email?: string;
  role: UserRole;
}

export interface AuthSession {
  token: string;
  user: AuthUser;
}

const AUTH_STORAGE_KEY = 'locum_auth_session';

export const saveAuthSession = (session: AuthSession): void => {
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(session));
};

export const getAuthSession = (): AuthSession | null => {
  const raw = localStorage.getItem(AUTH_STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw) as AuthSession;
  } catch {
    localStorage.removeItem(AUTH_STORAGE_KEY);
    return null;
  }
};

export const clearAuthSession = (): void => {
  localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const getAuthToken = (): string | null =>
  getAuthSession()?.token ?? null;

export const getAuthRole = (): UserRole | null =>
  getAuthSession()?.user.role ?? null;

export const isAuthenticated = (): boolean => Boolean(getAuthToken());
